@import "../../scss";

.root {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  appearance: none;
  border: none;
  background: none;
  width: 100%;
  height: 100%;
  padding: 0;
}

.root picture {
  width: 80%;

  @include media-breakpoint-down("md") {
    width: 100%;
  }

  @media (max-height: 600px) {
    width: 80%;
  }
}

.icon {
  width: 1.8rem;
  height: auto;
}

.image {
  display: block;
  width: 100%;
  height: auto;
  // margin-top: calc(var(--spacer-6) * -1);
  transition: transform 0.4s ease;
  aspect-ratio: 700/1312;
}

.root {
  @media (hover: hover) {
    @include hover {
      .image {
        transform: scale(1.05) translateY(-4%);
      }
    }
  }
}

.item-name {
  @include typo--button;
  display: block;
  color: var(--color-bright-green);
  opacity: 0;
  transition: opacity 0.3s ease;
  margin-bottom: var(--spacer-3);

  @media (hover: none) {
    margin-top: var(--spacer-1);
  }

  @include media-breakpoint-down("md") {
    margin-bottom: var(--spacer-1);
  }
}

.button {
  transition: opacity 0.4s ease, transform 0.4s ease 0.4s;
  opacity: 0;

  @media (hover: hover) {
    transform: translateY(80%);
  }
}

.root {
  @include hover {
    .item-name,
    .button {
      opacity: 1;
      transition: opacity 0.4s ease, transform 0.4s ease 0s;
      transform: translateY(0);
    }
  }
}

.item-name,
.button {
  @media (hover: none) {
    opacity: 1;
    transform: translateY(0);
  }
}
// :global(.swiper-slide-active) {
// }
